// SurveyStatusProvider — pide las encuestas del jugador una sola vez y las
// comparte con toda la app (ver hooks/surveyStatus). v6.11.329
// Vuelve a preguntar cuando la app vuelve al frente (como mucho una vez por
// minuto): una pareja que acaba de perder su partido de playoffs tiene que
// encontrarse con la encuesta al abrir la app, sin recargar.

import React, { useEffect, useRef } from 'react';
import { SurveyStatusContext } from '../hooks/surveyStatus';
import { useSurveyStatusSource } from '../hooks/usePendingSurveys';

const REFRESH_ON_FOCUS_MS = 60_000;

interface Props {
  /** false = sin jugador logueado o edición en solo lectura: no pide nada. */
  enabled: boolean;
  children: React.ReactNode;
}

export const SurveyStatusProvider: React.FC<Props> = ({ enabled, children }) => {
  const status = useSurveyStatusSource(enabled);
  const { refresh } = status;
  const lastFetch = useRef(0);

  useEffect(() => {
    if (!enabled) return;
    lastFetch.current = Date.now();
    const onVisible = () => {
      if (document.visibilityState !== 'visible') return;
      if (Date.now() - lastFetch.current < REFRESH_ON_FOCUS_MS) return;
      lastFetch.current = Date.now();
      refresh();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, [enabled, refresh]);

  return <SurveyStatusContext.Provider value={status}>{children}</SurveyStatusContext.Provider>;
};
